<template>
    <div id="network-counselors">
      <header-section v-bind:title='"Mạng lưới cố vấn"'></header-section>
      <div class='network-counselors-content container'>
        <tool-filter class="col-md-4"></tool-filter>
        <counselors class="col-md-8"></counselors>  
      </div>
    </div>
</template>
<script>
import HeaderSection from "./components/Common/HeaderSection.vue"
import ToolFilter from "./components/NetworkCounselor/ToolFilter.vue";
import Counselors from "./components/NetworkCounselor/Counselors.vue";
import { mapState, mapActions } from 'vuex';

var url = process.env.API_URL + process.env.API_VERSION;
export default {
  name: "components",
  components: {
    HeaderSection,
    Counselors,
    ToolFilter
  },
  // computed: mapState({
  //   products: state => state.products.all
  // }),
  created: function(){
    this.$store.dispatch('vuex_network_counselors/load_list_counselors', {page: this.$route.query.page})
    this.$store.dispatch('services/load_list_services')    
  },
  mounted: function(){    
    // console.log(this.info_page.user_info.name)
  },
};
</script>
<style scoped>
  .network-counselors-content.container{
    display: flex;
    flex-wrap: wrap;
    padding-top: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/views/NetworkCounselors.vue